/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Modal } from 'antd'

import { serverlessApi } from '../../../utils/API'
import { manageToast } from '../../../components/Common/ManageToast'

import InternalKeyForm from './Form'

function InternalKeyModal (props) {
  const {
    form,
    formName,
    handleClose,
    handleSubmit,
    editForm,
    initialValues,
    open,
    loading,
    internalKey,
    selectedProperty,
    setSelectedProperty,
    submitButtonLabel,
    title
  } = props

  const [properties, setProperties] = React.useState([])
  const [propertiesLoading, setPropertiesLoading] = React.useState(false)

  const fetchProperties = () => {
    setPropertiesLoading(true)

    serverlessApi.getKeysProperties().then(res => {
      if (res.status === 200) {
        const properties = res?.data.data || []
        const normalizedProperties = properties.filter(item => {
          return !item?.internalListingName?.toLowerCase()?.includes('communal area')
        }).map(item => ({
          label: item.internalListingName,
          value: item.id,
          key: item._id,
          data: { ...item }
        }))

        setProperties(normalizedProperties)
        setPropertiesLoading(false)
      }
    }).catch(() => {
      manageToast(false,'Error fetching properties.')
      setPropertiesLoading(false)
    })
  }

  React.useEffect(() => {
    if (open) {
      fetchProperties()
      form.setFieldsValue(initialValues)
    }
  }, [open, initialValues, form])

  React.useEffect(() => {
    if (open && internalKey) {
      setSelectedProperty(internalKey?.property)
    }
  }, [internalKey, open])

  return (
    <Modal
      title={title}
      open={open}
      footer={null}
      onCancel={handleClose}
    >
      <InternalKeyForm
        form={form}
        formName={formName}
        handleCancel={handleClose}
        handleSubmit={handleSubmit}
        editForm={editForm}
        loading={loading}
        properties={properties}
        propertiesLoading={propertiesLoading}
        selectedProperty={selectedProperty}
        setSelectedProperty={setSelectedProperty}
        submitButtonLabel={submitButtonLabel}
      />
    </Modal>
  )
}

export default InternalKeyModal
